import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@/components/ui/command";
import {
  LayoutDashboard,
  Users,
  CheckSquare,
  FileText,
  Bell,
  Activity,
  Settings,
  Plus,
  UsersRound,
} from "lucide-react";

export default function CommandPalette({ open, onOpenChange, onNewTask, onNewClient }) {
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        onOpenChange(!open);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [open, onOpenChange]);

  const go = (path) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Type a command or search..." data-testid="command-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => { onOpenChange(false); onNewTask?.(); }} data-testid="cmd-new-task">
            <Plus size={14} className="mr-2" /> New Task
          </CommandItem>
          <CommandItem onSelect={() => { onOpenChange(false); onNewClient?.(); }} data-testid="cmd-new-client">
            <Plus size={14} className="mr-2" /> New Client
          </CommandItem>
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Navigation">
          <CommandItem onSelect={() => go("/")}><LayoutDashboard size={14} className="mr-2" />Dashboard</CommandItem>
          <CommandItem onSelect={() => go("/clients")}><Users size={14} className="mr-2" />Clients</CommandItem>
          <CommandItem onSelect={() => go("/tasks")}><CheckSquare size={14} className="mr-2" />Tasks</CommandItem>
          <CommandItem onSelect={() => go("/documents")}><FileText size={14} className="mr-2" />Documents</CommandItem>
          <CommandItem onSelect={() => go("/notifications")}><Bell size={14} className="mr-2" />Notifications</CommandItem>
          <CommandItem onSelect={() => go("/activity")}><Activity size={14} className="mr-2" />Activity</CommandItem>
          <CommandItem onSelect={() => go("/users")}><UsersRound size={14} className="mr-2" />Team</CommandItem>
          <CommandItem onSelect={() => go("/settings")}><Settings size={14} className="mr-2" />Settings</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
